import { MessageSquare, MessageCircle, CheckCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

interface ConversationItemProps {
  id: string;
  name: string;
  lastMessage: string;
  timestamp: string;
  unread?: boolean;
  source: 'telegram' | 'whatsapp';
  isSelected: boolean;
  onClick: () => void;
}

export const ConversationItem = ({
  name,
  lastMessage,
  timestamp,
  unread,
  source,
  isSelected,
  onClick,
}: ConversationItemProps) => {
  return (
    <div
      className={cn(
        "flex items-start gap-3 p-4 cursor-pointer hover:bg-[#F0F2F5] transition-colors",
        isSelected && "bg-[#F0F2F5]"
      )}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
    >
      <div className="flex-shrink-0 w-12 h-12 bg-[#DFE5E7] rounded-full flex items-center justify-center">
        {source === 'telegram' ? (
          <MessageCircle className="h-6 w-6 text-[#54656F]" />
        ) : (
          <MessageSquare className="h-6 w-6 text-[#54656F]" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-start">
          <h4 className="text-sm font-medium text-[#111B21] truncate">
            {name}
          </h4>
          <span className="text-xs text-[#667781]">
            {formatDistanceToNow(new Date(timestamp), {
              addSuffix: true,
              locale: ptBR,
            })}
          </span>
        </div>
        <div className="flex items-center gap-1">
          {source === 'whatsapp' && (
            <CheckCheck className="h-4 w-4 text-[#53BDEB]" />
          )}
          <p className={cn(
            "text-sm truncate",
            unread 
              ? "text-[#111B21] font-medium" 
              : "text-[#667781]"
          )}>
            {lastMessage}
          </p>
        </div>
      </div>
      {unread && (
        <div className="flex-shrink-0 w-5 h-5 bg-[#25D366] rounded-full flex items-center justify-center">
          <span className="text-xs text-white font-medium">1</span>
        </div>
      )}
    </div>
  );
};